import { useState, useEffect } from "react";
import { Phone } from "lucide-react";

const LOGO_URL = "/logo.png";

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const navLinks = [
    { label: "Services", id: "services" },
    { label: "Réalisations", id: "portfolio" },
    { label: "Témoignages", id: "testimonials" },
  ];

  return (
    <nav
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#0A0A0A]/95 backdrop-blur-xl border-b border-[#2A2A2A]/50" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between h-20">
        {/* Logo */}
        <button onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} className="flex items-center gap-3" data-testid="navbar-logo">
          <img src={LOGO_URL} alt="Paysagement multi-concepts" className="h-12 md:h-14 w-auto object-contain" />
        </button>

        {/* Desktop links */}
        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="font-sans text-xs uppercase tracking-[0.2em] text-[#A1A1AA] hover:text-[#E8891C] transition-colors duration-300"
              data-testid={`nav-link-${link.id}`}
            >
              {link.label}
            </button>
          ))}
          <a
            href="tel:5148094242"
            className="flex items-center gap-2 text-[#E8891C] font-sans text-xs uppercase tracking-[0.15em]"
            data-testid="nav-phone"
          >
            <Phone size={14} />
            (514) 809-4242
          </a>
        </div>

        {/* Mobile menu toggle */}
        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden flex flex-col gap-1.5 w-7"
        >
          <span className={`block h-[1px] bg-[#F5F5F0] transition-all duration-300 ${menuOpen ? "rotate-45 translate-y-[4px]" : ""}`} />
          <span className={`block h-[1px] bg-[#F5F5F0] transition-all duration-300 ${menuOpen ? "opacity-0" : ""}`} />
          <span className={`block h-[1px] bg-[#F5F5F0] transition-all duration-300 ${menuOpen ? "-rotate-45 -translate-y-[4px]" : ""}`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-[#0A0A0A]/98 backdrop-blur-xl border-t border-[#2A2A2A]/50 px-6 py-8 space-y-6" data-testid="mobile-menu">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollTo(link.id)}
              className="block font-sans text-sm uppercase tracking-[0.2em] text-[#A1A1AA] hover:text-[#E8891C] transition-colors duration-300"
            >
              {link.label}
            </button>
          ))}
          <a href="tel:5148094242" className="flex items-center gap-2 text-[#E8891C] font-sans text-sm uppercase tracking-[0.15em]">
            <Phone size={14} />
            (514) 809-4242
          </a>
        </div>
      )}
    </nav>
  );
};
